import { Component } from '@angular/core';

@Component({
  selector: 'bb-identity-journey-wrapper',
  templateUrl: './journey-wrapper.component.html',
})
export class IdentityJourneyWrapperComponent {}
